import * as React from "react";
const SvgFiRrFolderTimes = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-folder-times_svg__a)">
      <path
        fill="#062147"
        d="M18.987 1.975H12.46c-.154 0-.31-.037-.447-.105L8.856.29a3 3 0 0 0-1.342-.315H4.987c-2.757 0-5 2.243-5 5v12c0 1.779.958 3.438 2.5 4.33a.999.999 0 1 0 1.001-1.73 3.01 3.01 0 0 1-1.5-2.6v-9h20v9a3.02 3.02 0 0 1-1.502 2.6 1 1 0 1 0 1.002 1.73 5.02 5.02 0 0 0 2.5-4.33v-10c0-2.757-2.244-5-5-5m-17 3c0-1.654 1.346-3 3-3h2.527c.154 0 .31.036.447.105l3.156 1.579c.415.206.88.315 1.341.315h6.528c1.302 0 2.402.839 2.816 2H1.987zm9.991 5c-3.859 0-7 3.14-7 7s3.141 7 7 7 7-3.141 7-7-3.14-7-7-7m0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5m1.707-4.707a.999.999 0 1 1-1.414 1.414l-1-1a1 1 0 0 1-.293-.707v-2a1 1 0 1 1 2 0v1.586z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-folder-times_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFolderTimes;
